import { useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import MeaButton from "../../../components/MeaButton";


const PreCheck = ({ onSubmit, loading = false }) => {

  const captchaRef = useRef(null);
  const [token, setToken] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    const token = captchaRef.current.getValue();
    setToken(token);
    onSubmit(token);
  };

  return (
    <div style={{ paddingTop: "30px" }} className="flex justify-content-center flex-wrap">
      <div style={{ maxWidth: "400px" }} className="surface-card p-4 shadow-2 border-round w-full lg:w-6">
        <div className="text-center mb-5">

          <div className="text-900 text-3xl font-medium mb-3">Pré-Vérification</div>
          <span className="text-600 font-medium line-height-3">Veuillez vérifier votre identité pour accéder à votre espace</span>
        </div>

        <div>
          <form onSubmit={handleSubmit}>

            <div className="flex align-items-center justify-content-between mb-6">
              <div className="flex align-items-center">
              </div>
            </div>
            <div className="flex align-items-center justify-content-between mb-4">
              <ReCAPTCHA
                sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                onChange={(value) => {
                  setToken(value);
                }}
                ref={captchaRef}
              ></ReCAPTCHA>
            </div>
            <MeaButton disabled={token === null} style={{ height: "50px" }} label="Vérifier" icon="pi pi-user" className="w-full" loading={loading} />

          </form>
        </div>

      </div>

    </div>
  );
};

export default PreCheck;